module.exports = __webpack_public_path__ + "img/spoken_senten.fd4bc063.svg";